import { createContext } from 'react'
import {
    DivProps,
    PaginationType,
    ReactTableInstance,
    ReactTableNoResultsRow,
    ReactTableRows,
    ReactTableState,
    RowProps,
    TableRowSize,
} from './interface'

interface Props {
    instance: ReactTableInstance<any>
    pagination?: PaginationType
    sticky?: boolean
    loading?: boolean
    elevation?: boolean
    displayFooter?: boolean
    itemsTotalCount?: number
    noResultsRow?: ReactTableNoResultsRow
    tableState?: ReactTableState<any>
    tableProps?: React.HTMLAttributes<HTMLDivElement>
    bodyProps?: React.HTMLAttributes<HTMLDivElement>
    expanded?: boolean | ((props: { row: ReactTableRows<any> }) => React.ReactNode)
    size?: TableRowSize
    rowContainerProps?: ((row: ReactTableRows<any>) => DivProps) | DivProps
    rowProps?: RowProps<any>
    cellProps?: any
    backgroundColor?: string
    bordered?: boolean
    headerProps?: React.HTMLAttributes<HTMLDivElement>
    innerTable?: boolean
}

const ReactTableContext = createContext<Props>({} as any)

export default ReactTableContext
